/**
 * Machine QR codes, read exactly as the Android app reads them
 * (ASEED common/utils/QRCodeUtils.kt):
 *
 *   printed on the machine   http(s)://<anything>?QRC-XXXXXXX-XX-XX
 *   sent to the server       QRC-XXXXXXX-XX-XX
 *
 * Anything else is not a machine of ours, and is refused before any request
 * is made: opening an upstream order is not repeatable.
 */

const QRC = /QRC-\S+/;
const MACHINE_URL = /^https?:\/\/\S*\?QRC-\S+$/;

/** The code to send for a scanned or typed value, or null if it is not one. */
export function machineCodeFrom(raw: string): string | null {
  const text = raw.trim();
  if (!text) return null;
  if (MACHINE_URL.test(text)) return text.match(QRC)?.[0] ?? null;
  // Typed by hand: the code itself, as printed under the QR.
  if (/^QRC-\S+$/.test(text)) return text;
  return null;
}

/**
 * A code carried in this page's own address: `/app/?QRC-…` (the machine's
 * printed form, if the QR ever points here) or `/app/?qr=<value>`.
 */
export function machineCodeFromLocation(search: string): string | null {
  const params = new URLSearchParams(search);
  const explicit = params.get("qr");
  if (explicit) return machineCodeFrom(explicit);
  const bare = search.replace(/^\?/, "");
  if (bare.startsWith("QRC-")) return machineCodeFrom(decodeURIComponent(bare.split("&")[0] ?? ""));
  return null;
}
